import React from 'react'
import {Box} from '../../webui/Box'
import {Paper} from '../../webui/Paper'
import {LoadingSpinnerContainer} from '../../webui/progress/LoadingSpinnerContainer'
import {BatteryMap} from './BatteryMap'
import {useLatestBatteryReadingPerBox} from './gql/useLatestBatteryReadingPerBox'
import {LatestBatteryReadingPerBoxTable} from './LatestBatteryReadingPerBoxTable'
import {getLatestBatteryReadingPerBox} from './utils/getLatestBatteryReadingPerBox'
import {resolveBatteryStatuses} from './utils/resolveBatteryStatuses'

interface Props {}

export const BoxBatteryHistoryPage: React.FC<Props> = () => {
  const {data: batteryReadings, loading: loadingBatteryReadings} = useLatestBatteryReadingPerBox()

  if (loadingBatteryReadings) {
    return <LoadingSpinnerContainer />
  }

  const boxesWithLatestReading = getLatestBatteryReadingPerBox(batteryReadings)

  return (
    <div>
      <Paper>
        <Box mb={2}>
          <BatteryMap batteryStatuses={resolveBatteryStatuses(Object.values(boxesWithLatestReading))} />
        </Box>
      </Paper>
      <Paper>
        <Box mb={2}>
          <LatestBatteryReadingPerBoxTable readings={Object.values(boxesWithLatestReading)} />
        </Box>
      </Paper>
    </div>
  )
}
